<template>
  <v-dialog v-model="dialogShare" max-width="500px" scrollable>
    <template v-slot:activator="{ props }">
      <v-list-item v-bind="props" disabled>
        <template v-slot:prepend>
          <v-icon color="primary" class="opacity-100">mdi-account-plus</v-icon>
        </template>
        <v-list-item-title>{{ $t("labels.share") }}</v-list-item-title>
      </v-list-item>
    </template>
    <v-card height="auto">
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.sharing") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="dialogShare = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="mt-2">
        <shareForm
          :share-form-config="shareFormConfig"
          :realm="realm"
          :item-to-share="mutableItem"
          :root="'flows'"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import shareForm from "@/components/ShareForm.vue";

export default {
  name: "DialogShare",
  components: { shareForm },
  data() {
    return {
      tenantId: this.realm,
      mutableItem: {},
      dialogShare: false,
    };
  },
  props: {
    realm: String,
    itemToShare: {},
    shareFormConfig: {},
  },
  watch: {
    itemToShare: {
      immediate: true,
      handler(newItem) {
        this.mutableItem = newItem || {};
      },
    },
  },
};
</script>

<style scoped></style>
